module.exports = __webpack_public_path__ + "img/H1.8d0090e5.png";